<template>
  <div class="form_warpper">
    <el-form :model="loginForm" :rules="loginRoules" ref="loginForm" label-width="0px" class="login-content">
      <slot name="name"></slot>
      <el-form-item prop="username">
        <el-input class="input_style" v-model="loginForm.username" :placeholder="loginType.placeholderNameOne">
          <el-button slot="prepend" :icon="loginType.placeholderNameOne !=='手机号' ?'el-icon-user':'el-icon-mobile-phone'"></el-button>
        </el-input>
      </el-form-item>
      <slot name="forget"></slot>
      <el-form-item prop="password">
        <el-input class="input_style" v-model="loginForm.password" :placeholder="loginType.placeholderNameTwo" :type="loginType.inputType" @keyup.enter.native="loginHandle('loginForm')">
          <el-button slot="prepend" :icon="loginType.type ? 'el-icon-lock' : 'el-icon-chat-dot-square' "></el-button>
          <el-button v-if="!loginType.type" slot="append" type="primary" class="sendBtn" @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button>
        </el-input>
      </el-form-item>
      <slot name="code"></slot>
      <el-form-item v-if="loginType.type && loginType.imgCaptcha"  class="input_code">
        <el-input prop="imgCaptcha" v-model="loginForm.imgCaptcha" size="large" type="text"  placeholder="请输入图形验证码"></el-input>
      </el-form-item>
      <el-form-item v-if="loginType.type &&loginType.imgCaptcha" class="image_code">
        <el-image :src="getImgUrl" @click="handleChangeCheckCode">
        </el-image>
      </el-form-item>

      <slot name="termHandle"></slot>
      <div class="loginBtn">
        <el-button type="primary" @click="loginHandle('loginForm')">{{
          submit
        }}</el-button>
      </div>
      <!-- <div class="footer">
        <el-button class="align" @click="onAlign('1')" v-show="align">{{ align }}</el-button>
        <el-button class="align" @click="onAlign('2')" v-show="align2">{{ align2 }}</el-button>
      </div> -->
    </el-form>
  </div>
</template>

<script>
import { getCaptcha, getPharmacistCaptcha } from '@/api'
import util from '@/utils'

export default {
  components: {},
  props: {
    fromType: String,
    submit: String,
    align: String,
    align2: String,
    lock: String,
    loginType: {
      type: Object,
      default () {
        return {  //默认值用于注册页面使用
          type: true,
          imgCaptcha: false,
          inputType: 'password',
          placeholderNameOne: "手机号 / 用户名",
          placeholderNameTwo: "请输入密码",
          placeholderNameThree: "请输入验证码"

        }
      }
    }
  },
  data () {
    return {
      loginRoules: {
        username: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码或验证码",
            trigger: "blur",
          },
        ],
        imgCaptcha: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
      //  Captcha: [
      //     {
      //       required: true,
      //       message: "请输入验证码",
      //       trigger: "blur",
      //     },
      //   ],
      },
      loginForm: {
        username: '',
        password: '',
        imgCaptcha: ''
      },
      code_time: 60,
      code_tip: "发送验证码",
      sendCodeBtnDisable: false,
      randCodeImage: '',
      requestCodeSuccess: false,
      getImgUrl: ''
    };
  },
  mounted () {
    this.handleChangeCheckCode();
  },

  methods: {
    loginHandle (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let userInfo = this.loginForm;
          this.$emit("on-submit", userInfo);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onAlign (type) {
      this.$emit("on-align", type);
      console.log(type)
    },
    /*
    *  注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
    * */
    async sendPhoneCode () {
      try {
        /**
         * 获取组件中表单中的手机号码
         */
        let mobile = this.loginForm.username;
        if (mobile === "") {
          this.elementTips("error", "手机号码不能为空");
          return;
        }
        const params = {
          smsMode: "1",
          mobile: mobile,
        };
        let res = await getCaptcha(params);
        if (res.success) {
          this.countDown();
          this.elementTips("success", res.message);
          this.sendCodeBtnDisable = true;
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 倒计时
     * */
    countDown () {
      const that = this;
      const timer = setInterval(() => {
        that.code_tip = this.code_time + "s";
        that.code_time--;
        if (that.code_time < 0) {
          clearInterval(timer);
          that.sendCodeBtnDisable = false;
          that.code_tip = "获取验证码";
          that.code_time = 60;
        }
      }, 1000);
    },
    /*
    * 提示信息
    * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },

    // inputCodeChange (e) {
    //   this.inputCodeContent = e.target.value
    // },
    async handleChangeCheckCode () {
      console.log(1234)
      try {
        this.currdatetime = new Date().getTime();
        const params = {
          key: this.currdatetime,
        };
        let { code, data } = await getPharmacistCaptcha(params);
        if (code === 1) {
          this.getImgUrl = data.captcha
          this.loginForm.salt = data.salt
          this.loginForm.checkKey = this.currdatetime
          this.requestCodeSuccess = true
        } else {
          this.$message.error(message)
          this.requestCodeSuccess = false
        }
      } catch (error) {
        this.requestCodeSuccess = false
      }
    },
  },
  watch: {
    loginType: function () {  //每次切换登录类型清空密码输入框
      this.loginForm.password = ''
    },


  },
};
</script>

<style lang="scss" scoped>
.form_warpper {
  width: 100%;
}
.login-title {
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  // color: #fff;
  color: #606266;
  border-bottom: 1px solid #ddd;
  font-family: Noto Sans S Chinese;
  font-weight: 500;
}

.input_code {
  width: 60%;
  float: left;
}

.image_code {
  width: 35%;
  float: right;
}

.login-content {
  padding: 30px 30px;

  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }

  .sendBtn {
    color: #fff;
    border-radius: 0;
  }

  .tip {
    font-size: 14px;
    color: #ddd;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    .align {
      font-size: 14px;
      color: #fc701a;
      cursor: pointer;
      width: 100%;
      height: 36px;
      border-radius: 6px;
      border: 1px solid #fc701a;
      background: #fff;
    }
    // .align:active{
    //   border:1px solid #FC701A;
    // }
  }
  /deep/.el-input__inner:focus {
    border: 1px solid #fc701a;
  }
}
</style>
